<template>
  <section id="WinReEntry" class="win-re-entry" :class="{'visible':!isTransitioning}">
    <div class="content-general">
      <h2>Submit Your Email</h2>
      <p>We'll retrieve your entry information.</p>
      <form @submit.prevent="submitForm" :class="['form', {'loading': isLoading}]">

        <div class="form-row">
          <div class="form-group" :class="{error: readyToValidate && (!email || !validateEmail(email))}">
            <input id="email" name="email" type="text" placeholder="*Email Address" @change="validateForm" v-model="email" tabindex="1">
          </div>
        </div>
        
        <div class="form-row submit">
          <button id="submit" class="btn submit-button">Submit</button>
          <div class="error-message" v-if="this.readyToValidate && !this.formValid" v-html="this.message"></div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import store from '../store'
import axios from 'axios'

export default{
  name: 'win-re-entry',
  data(){
    return {
      email: '',
      readyToValidate: false,
      formValid: false,
      isLoading: false,
      message: '',
    }
  },
  computed: {
    isTransitioning() {
      return store.state.isTransitioning
    },
    hasErrors(){
      return this.readyToValidate && this.formValid 
    }
  },
  mounted() {
    const _this = this
    setTimeout(function(){
      _this.$emit('sectionHeightChange')
    }, 500)
  },
  methods:{
    openModal(whichModal) {
      store.commit('openModal', whichModal)
    },
    validateForm(){
      this.formValid = true
      this.message = ''

      if(!this.validateEmail(this.email)){
        this.formValid = false
        this.message += 'The email you entered is invalid'
      }
    },

    submitForm(){
      this.readyToValidate = true
      this.validateForm()
      if(this.formValid){
        this.getUserData()
      }
    },

    getUserData(){
      store.commit('showLoader')
      axios.post(`${store.state.backendUrl}/getUserEntries`, {email: this.email}).then(resp => {
        this.isLoading = false
        store.commit('setCreated', resp.data.created)
        store.commit('setSteps', resp.data.steps)
        this.$cookies.set('user', resp.data, -1)
        this.goToWinEmailEntry()
      }).catch((err) => {
        this.formValid = false
        this.isLoading = false
        this.message = err.response.data === 'user not found'? 'No user found. Try signing up using that email address to be entered to win.':'There was a problem finding your data. Please try again later.'
        console.log(err.response)
      }).finally(() => {
        store.commit('hideLoader')
      })
    },

    validateEmail(emailAddr){
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailAddr)
    },

    goToWinEmailEntry() {
      store.commit('goToWinEmailEntry')
    }
  }
}
</script>

<style scoped lang="scss">
/** split-container **/
@import '../theme';

.error-message{
  color: red;
  margin: 0 0 30px 0;
}

.win-re-entry {
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateX(100%);
  z-index: zespri-layer(normal);
  transition: all .5s;
  
  .content-general {
    max-width: 630px;
    margin: 50px auto 50px;
    transition: opacity .5s;
    
    @include media-breakpoint-up(md) {
      margin: 0 auto 50px;
    }
  }
  
  &.visible {
    transform: translateX(0);
    opacity: 1;
  }
}

.step-num {
  @include zespri-mid-title;
}

.form {
  display: block;
  margin-top: 35px;
}

.form-row {
  display: flex;
  flex-direction: column;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    margin-bottom: 10px;
  }

  &.submit {
    @include media-breakpoint-up(md) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}

.form-group {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 25px;
  @include clearfix;
  width: 100%;

  @include media-breakpoint-up(md) {
    width: 50%;
    margin: 0 auto 15px;
  }

  &.checkbox {
    margin-bottom: 10px;
    @include media-breakpoint-up(md) {
      margin-bottom: 10px;
    }
  }
}

.form-group.centered{
  margin-left: auto;
  margin-right: auto;
}

.form-group-sub {
  width: 45%;
  float: left;
  &+.form-group-sub{
    margin-left: 10%;
  }
}

label {
  display: inline-block;
  margin-bottom: 13px;
}

label a{
  text-decoration: underline;
  cursor: pointer;
}

.error {
  input[type=text]{
    border-color: red;
  }

  input[type=checkbox]{
    + label {
      &:before {
        border-color: red;
      }
    }
  }

  label {
    color: red;
  }

  .fake-city-select {
    border-color: red;
  }
}

input[type=text] {
  @include zespri-button-text;
  padding: 8px 10px;
  background: zespri-brand-color(off-white);
  border: none;
  border: 2px solid zespri-brand-color(dark-green);
  border-radius: 5px;
  display: block;
  width: 100%;
  color: zespri-brand-color(dark-green);
  transition: border-color .2s;

  &:focus {
    outline: none;
    border-color: zespri-brand-color(green);
  }
}

input[type=checkbox] {
  position: absolute;
  left: -999999px;
  $label-hw: 15px;

  + label {
    @include noselect;
    padding-top: 2px;
    padding-left: $label-hw + 10;
    position: relative;

    &:before {
      content: '';
      border: 2px solid zespri-brand-color(dark-green);
      border-radius: 5px;
      display: block;
      height: $label-hw;
      position: absolute;
      top: 0;
      left: 0;
      width: $label-hw;
      transition: background-color .2s;
    }
  }

  &:checked {
    + label:before {
      background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 30 30' style='enable-background:new 0 0 30 30;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFCC00;%7D%0A%3C/style%3E%3Ctitle%3Echeck%3C/title%3E%3Cpath class='st0' d='M21.9,12.4c0.7-0.8,0.7-2,0-2.8c-0.7-0.7-1.9-0.8-2.6,0c0,0,0,0,0,0L13,16l-2.3-2.3c-0.7-0.7-1.9-0.8-2.6,0 c0,0,0,0,0,0c-0.7,0.8-0.7,2,0,2.8l4,4.1c0.5,0.5,1.4,0.6,1.9,0c0,0,0,0,0,0L21.9,12.4z'/%3E%3C/svg%3E");
      background-color: zespri-brand-color(dark-green);
      background-size: 120%;
      background-position: 35% 40%;
    }
  }
}

.submit-button {
  @include cta-button-large(zespri-brand-color(white), zespri-brand-color(dark-green), zespri-brand-color(green));
  margin: 0 0 30px 0;
}

.city-select-wrapper {
  position: relative;
  width: 100%;
}

.city-select {
  position: relative;
  z-index: 9;
  height: 34px;
  width: 100%;
  border-radius: 5px;

  &:focus {
    outline: 0;
    border: 0;

    + .fake-city-select {
      border-color: zespri-brand-color(green);
    }
  }
}

.fake-city-select {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  border: 2px solid zespri-brand-color(dark-green);
  border-radius: 5px;
  background: zespri-brand-color(off-white);
  outline: none;
  color: zespri-brand-color(dark-green);
  text-align: left;
  transition: all .2s;
  pointer-events: none;
  padding: 5px 10px;

  &:after {
    content: "";
    position: absolute;
    right: 12px;
    top: 12px;
    display: inline-block;
    width: 16px;
    height: 8px;
    border: 0;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='22px' height='13px' viewBox='0 0 22 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate%28-724.000000, -167.000000%29' stroke-width='2' stroke='%23D1D1D1'%3E%3Cg id='dropdown' transform='translate%28377.000000, 148.000000%29'%3E%3Cpolyline id='Path-3' transform='translate%28358.000000, 25.000000%29 rotate%2890.000000%29 translate%28-358.000000, -25.000000%29 ' points='353 15 363 24.8984656 353 35'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 16px 8px;
    transition: all .2s;
  }

  .fake-selected-state, .fake-placeholder {
    @include zespri-button-text;
  }
  .fake-selected-state {
    color: zespri-brand-color(dark-green);
  }
  .fake-placeholder {
    color: #777;
  }
}

</style>
